import React, { useMemo, useState } from 'react'
import { PresentModeContext } from './present-mode'
import DirectPresent from './direct-present'
import { apiGetPresentation } from '../../../common/api/lesson'
import { errorHandler } from 'pobble-components/dist/error-handler'

const PresentModeProvider = ({ children }) => {
  const [presentation, setPresentation] = useState(null)
  const [options, setOptions] = useState(null)

  const value = useMemo(
    () => ({
      presentation: presentation,
      isPresenting: !!presentation,
      options,
      present: (presentation, options) => {
        setOptions(options)
        if (typeof presentation === 'string') {
          setPresentation('pending')
          apiGetPresentation(presentation, {
            include:
              'presentation.audio,presentation.image,presentation.recommended_until,presentation.category,presentation.year_groups,presentation.year_group.order,presentation.details,presentation.names,presentation.slides,presentation.slide.details,presentation.slide.type'
          })
            .then(res => setPresentation(res.data.presentation))
            .catch(errorHandler)
        } else {
          setPresentation(presentation)
        }
      }
    }),
    [presentation, options]
  )

  return (
    <PresentModeContext.Provider value={value}>
      {children}
      {!!presentation && (
        <DirectPresent
          onClose={() => {
            if (options && options.onClose) options.onClose()
            setOptions(null)
            setPresentation(null)
          }}
          data={presentation}
        />
      )}
    </PresentModeContext.Provider>
  )
}

export default PresentModeProvider
